import { render, staticRenderFns } from "./download-payments.vue?vue&type=template&id=d7dff2cc&"
import script from "./download-payments.vue?vue&type=script&lang=js&"
export * from "./download-payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7dff2cc')) {
      api.createRecord('d7dff2cc', component.options)
    } else {
      api.reload('d7dff2cc', component.options)
    }
    module.hot.accept("./download-payments.vue?vue&type=template&id=d7dff2cc&", function () {
      api.rerender('d7dff2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/payment/download-payments.vue"
export default component.exports